import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-pre-auth-layout',
    templateUrl: './pre-auth-layout.component.html',
    styleUrls: ['./pre-auth-layout.component.scss'],
    standalone: false
})
export class PreAuthLayoutComponent {
  constructor(public router: Router) {
  }
}
